import jwtDecode from "jwt-decode";
import {
    AUTH_TOKEN,
    AUTHENTICATED,
    SHOW_AUTH_MESSAGE,
    HIDE_AUTH_MESSAGE,
    SIGNOUT_SUCCESS,
    SIGNUP_SUCCESS,
    SHOW_LOADING,
    SIGNIN_WITH_GOOGLE_AUTHENTICATED,
    SET_JWT,
    CLEAR_JWT,
    SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
    PERMISSIONS,
    SET_AUTH_USER,
} from "../constants/Auth";

const initState = {
    loading: false,
    message: "",
    showMessage: false,
    redirect: "",
    token: null,
    permissions: null,
    user: null,
};
const clearLocalStorage = () => {
    Object.keys(localStorage)
        .filter((item) => item !== "locale")
        .forEach((key2) => localStorage.removeItem(key2));
};
const checkExpiration = (tokenExpiry) => {
    let crtTime = parseInt(new Date().getTime() / 1000);
    if (tokenExpiry === undefined || tokenExpiry < crtTime) {
        clearLocalStorage();
        return false;
    }
    return true;
};
const necessaryAuthValues = () => {
    let initt = { ...initState };
    try {
        let arr = [
            { initName: "token", localName: AUTH_TOKEN },
            { initName: "permissions", localName: PERMISSIONS },
            { initName: "user", localName: "jwt", sub: "user" },
        ];
        let i = 0;
        let cont = true;

        while (cont && i < arr.length) {
            let localValue = localStorage.getItem(`${arr[i].localName}`);

            if (!localValue || localValue === "undefined") {
                cont = false;
                clearLocalStorage();
                initt = { ...initState };
            } else {
                if (arr[i].sub !== undefined) {
                    initt[arr[i].initName] =
                        JSON.parse(localValue)?.[arr[i].sub];
                } else {
                    initt[arr[i].initName] = localValue;
                }
            }
            i++;
        }
        if (i === arr.length) {
            const { exp } = jwtDecode(initt.token);

            if (!checkExpiration(exp)) {
                initt = {
                    ...initState,
                    message: "Session was expired",
                    showMessage: true,
                };
            }
        }
    } catch (error) {}
    return initt;
};
const auth = (state = necessaryAuthValues(), action) => {
    switch (action.type) {
        case AUTHENTICATED: {
            return {
                ...state,
                loading: false,
                redirect: "/",
                token: action.user.token,
                tokenExpiry: action.user.tokenCreated,
                permissions: action.user.permissions,
            };
        }

        case SHOW_AUTH_MESSAGE:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false,
            };

        case SET_AUTH_USER:
            return {
                ...state,
                user: action.payload,
            };

        case HIDE_AUTH_MESSAGE:
            return {
                ...state,
                message: "",
                showMessage: false,
            };
        case SIGNOUT_SUCCESS: {
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("jwt");
            localStorage.removeItem("permissions");
            return {
                ...state,
                token: null,
                redirect: "/",
                loading: false,
            };
        }
        case SIGNUP_SUCCESS: {
            return {
                ...state,
                loading: false,
                redirect: "/",
                token: action.user.token,
                permissions: action.user.permissions,
            };
        }
        case SHOW_LOADING: {
            return {
                ...state,
                loading: true,
            };
        }
        case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
            return {
                ...state,
                loading: false,
                token: action.token,
            };
        }
        case SIGNIN_WITH_FACEBOOK_AUTHENTICATED: {
            return {
                ...state,
                loading: false,
                token: action.token,
            };
        }
        case SET_JWT:
            localStorage.setItem("jwt", JSON.stringify(action.payload));
            return {
                ...state,
                loading: false,
                redirect: "/",
                token: action.payload.token,
            };
        case CLEAR_JWT:
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("jwt");
            return null;
        default:
            return state;
    }
};

export default auth;
